// Models
import { ContentType } from "../client/planner/common/IItemBody";
/**
 * Serializes the given notes into a resource format.
 * @param notes The notes to serialize
 */ export function serializeNotes(notes) {
    if (!notes) {
        return null;
    }
    return {
        content: notes.content,
        contentType: ContentType.HTML
    };
}
/**
 * Deserializes the given resource into notes.
 * @param resource The resource to deserialize
 */ export function deserializeNotes(resource) {
    if (!resource) {
        return null;
    }
    return {
        content: resource.content,
        contentType: ContentType.HTML
    };
}
